<template>
  <v-sheet v-if="currentBanner.banner && currentBanner.title" class="hero-bg mx-16 mt-2" min-height="600" :style="{backgroundImage: `url(${currentBanner.banner})`}" >
    <v-container class="text-center">
      
      <!-- banner content -->
      <v-responsive max-width="800" class="mx-auto pt-8">
        <h1 class="text-h1 mt-10 mx-4 white--text lato-font dropshadow" style="font-size: 3.7rem !important;">{{ currentBanner.title | uppercase }}</h1>
        <div v-if="currentBanner.title" class="text-h6 font-weight-bold mt-3 mb-3 mx-4 white--text lato-font dropshadow">Discover Your Perfect Coverage Plan in Just a Few Clicks</div> 
        <div v-if="false" class="text-h6 font-weight-bold mt-3 mb-3 mx-4 white--text lato-font ">Premium Protection for Every Journey!</div> 
      </v-responsive>

      <!-- button -->
      <v-responsive max-width="800" class="mx-auto">
        <v-btn 
          v-if="attributes.PublicOrders === true || attributes.PublicOrders === 'true'"
          id="app"
          color="orange"
          depressed 
          x-large
          class="mt-4 pl-10 pr-10 white--text rounded-0 darken-4 rounded-btn lato-font"
          @click="orderPage"
        >
          GET QUOTE
        </v-btn>
        <v-btn 
          v-else-if="attributes.PublicManage === true || attributes.PublicManage === 'true'"
          id="app"
          color="orange"
          depressed
          x-large
          class="mt-4 pl-10 pr-10 white--text rounded-0 darken-4 rounded-btn lato-font"
          @click="managePage"
        >
          MANAGE COVERAGE
        </v-btn>
      </v-responsive>
    </v-container>
  </v-sheet>
  <v-sheet 
    v-else
  >
    <v-container class="mb-1">
    </v-container>
  </v-sheet>
</template>

<script>
import { mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      currentBanner: 'microsite/currentBanner'
    }),
    ...mapState({
      meta: (state) => state.microsite.meta
    }),
    attributes() {
      return this.meta?.attributes || {}
    }
  },
  methods: {
    orderPage() {
      window.location.href = '/order'
    },
    managePage() {
      window.location.href = '/manage-coverage'
    }
  }
}
</script>
<style scoped>
.hero-bg {
  position: relative;
  background-size: cover;
  background-position: left;
  margin: 0 auto; 
  border-radius: 10px; 
  overflow: hidden;
}

/* Dark overlay for background image */
.hero-bg::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(5, 30, 40, 0.3); /* Adjust transparency */
}

/* Optional: Add drop shadow for better text visibility */
.dropshadow {
  text-shadow: 2px 2px 0px rgba(0, 0, 0, 0.3);
}

/* Button adjustments */
.rounded-btn {
  border-radius: 4px !important;
}
</style>